import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./WorkplaceApproval.css";
import { WorkplaceApprovalForm } from './WorkplaceApprovalForm';
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";



const WorkplaceApprovalRef = React.createRef();
const utils = new ViewUtils();

class WorkplaceApproval extends Component {

    constructor(props) {
        super(props);

        this.state = {
            WorkplaceApprovalDetails: {
                LegalName: "",
                SDLNumber: "",
                AccreditationCheck: false
            },
            RequiredFields: null,
            showTable: true,
            toolbarConfig:{
                items: [
                    {
                        type: "buttonGroup",
                        buttons: [
                            { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                        ]
                    },
            
                    {
                        type: "devider"
                    },
            
                    {
                        type: "buttonGroup",
                            buttons: [
                                { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Edit},
                                { id: 'contacts', label: 'Contacts', tooltip: '', disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalContacts').View },
                                { id: 'users', label: 'Users', tooltip: '', disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalUsers').View },
                                {
                                    contextMenu: [
                                        { id: "qualification", description: "QCTO Qualification", disabled: !this.props.onMenuSpecificPermissionItem('/WorkplaceApprovalQCTOQualificationsSearch').View },
                                        { id: "skillsProgramme", description: "QCTO Skills Programmes", disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalQCTOSkillsProgrammeSearch').View },
                                        { id: "learnerships", description: "QCTO Learnerships", disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalQCTOLearnershipSearch').View }
            
                                    ],
                                    id: 'programs', label: 'Programmes'
                                },
                                { id: 'learners', label: 'Learners', tooltip: '', disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalLearner').View },
                                { id: 'coachmentor', label: 'Coach/Mentor', tooltip: '', disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalCoachMentorSearch').View },
                                { id: 'documents', label: 'Documents', tooltip: '', disabled: !this.props.onMenuSpecificPermissionItem('/workplaceApprovalDocuments').View }
            
                            ]
                    }
                ]
            }
            
        };
    }

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {

            //if (!utils.isNull(values.WorkplaceApprovalStatusID) && !utils.isNull(values.WorkplaceApprovalStartDate)) {
            //    if (!utils.isNull(values.WorkplaceApprovalStartDate)) {
            //        //Remember to change this from checking using Id as this can change in the database
            //        if (values.WorkplaceApprovalStatusID.Id === "2") {
            //            utils.autoSetDate(this, WorkplaceApprovalRef, values.WorkplaceApprovalStartDate, 2, 0, 1, "WorkplaceApprovalEndDate", "WorkplaceApprovalStartDate");
            //        }
            //        else if (values.WorkplaceApprovalStatusID.Description === "Accredited") {
            //            utils.autoSetDate(this, WorkplaceApprovalRef, values.WorkplaceApprovalStartDate, 5, 0, 1, "WorkplaceApprovalEndDate", "WorkplaceApprovalStartDate");
            //        }
            //    }

            //    //if (values.WorkplaceApprovalStatusID.Description === "Full Accreditation") {
            //    //    let requiredFields = {
            //    //        DHETRegistrationStartDate: "DHETRegistrationStartDate",
            //    //        DHETRegistrationEndDate: "DHETRegistrationEndDate",
            //    //        DHETRegistrationNumber: "DHETRegistrationNumber"
            //    //    };

            //    //    this.setState({ RequiredFields: requiredFields })
            //    //}
            //    else {
            //        this.setState({ RequiredFields: null });
            //    }
            //}
            this.setState({ WorkplaceApprovalDetails: values});
        }
    }

    dateChange = (form, date) => {

        if (!utils.isNull(form.values.WorkplaceApprovalStatusID) && !utils.isNull(form.values.WorkplaceApprovalStartDate)) {
            if (!utils.isNull(form.values.WorkplaceApprovalStartDate)) {
                
                if (form.values.WorkplaceApprovalStatusID.Id === "2") {
                    utils.autoSetDate(this, WorkplaceApprovalRef, form.values.WorkplaceApprovalStartDate, 2, 0, 1, "WorkplaceApprovalEndDate", "WorkplaceApprovalStartDate");
                }
                else if (form.values.WorkplaceApprovalStatusID.Description === "Approved") {
                    utils.autoSetDate(this, WorkplaceApprovalRef, form.values.WorkplaceApprovalStartDate, 5, 0, 1, "WorkplaceApprovalEndDate", "WorkplaceApprovalStartDate");
                }
            }
            else {
                this.setState({ RequiredFields: null });
            }
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        }
        else if ("close" === buttonId) {
            this.closeView();
        }
        else if ("contacts" === buttonId) {
            this.props.history.push({
                pathname: '/WorkplaceApprovalContacts',
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            });
        }
        else if ("users" === buttonId) {
            this.props.history.push({
                pathname: '/WorkplaceApprovalUsers',
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
        else if ("learners" === buttonId) {
            this.props.history.push({
                pathname: '/WorkplaceApprovalLearner',
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
        else if ("coachmentor" === buttonId) {
            this.props.history.push({
                pathname: "/WorkplaceApprovalCoachMentorSearch",
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
        else if ("documents" === buttonId) {
            this.props.history.push({
                pathname: "/WorkplaceApprovalDocuments",
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
    }

    handleToolbarButtonMenuClick(menu) {
       
        if ("skillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: "/WorkplaceApprovalQCTOSkillsProgrammeSearch",
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    isAccredited: this.state.WorkplaceApprovalDetails.AccreditationCheck,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
        else if ("learnerships" === menu.id) {
            this.props.history.push({
                pathname: "/WorkplaceApprovalQCTOLearnershipSearch",
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    isAccredited: this.state.WorkplaceApprovalDetails.AccreditationCheck,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
        else if ("qualification" === menu.id) {
            this.props.history.push({
                pathname: "/workplaceApprovalQCTOQualificationsSearch",
                state: {
                    selection: this.props.location.state.selection,
                    WorkplaceApprovalName: this.state.WorkplaceApprovalDetails.LegalName,
                    isAccredited: this.state.WorkplaceApprovalDetails.AccreditationCheck,
                    WorkplaceApprovalSDLNumber: this.state.WorkplaceApprovalDetails.SDLNumber
                }
            })
        }
    }

    successCallback = (response) => {

        this.setState({
            message: response.Message, messageStyle: response.MessageType,
            showTable: false
        }, () => {
            this.setState({ message: response.Message, messageStyle: response.MessageType, showTable: true })
        });
    }

    save() {
        let formValue = WorkplaceApprovalRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {

            utils.invokeUrl("api/sims/WorkplaceApprovaldetails/UpdateWorkplaceApproval", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(formValue)
            });
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/WorkplaceApprovalSearch',
            state: { selection: this.props.location.state.WorkplaceApprovalID }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">

                <p className="breadcrumbs">
                    {"Workplace Approval " + (this.state.WorkplaceApprovalDetails.LegalName !== null ? "> " + this.state.WorkplaceApprovalDetails.LegalName + (this.state.WorkplaceApprovalDetails.SDLNumber !== null ? " - " + this.state.WorkplaceApprovalDetails.SDLNumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false} title="WorkplaceApproval" buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)} enabled={true} config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "55vh", maxHeight: "55vh" }}>
                                    {this.state.showTable === true && (
                                        <WorkplaceApprovalForm
                                            ref={WorkplaceApprovalRef}
                                            id={this.props.location.state.selection}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                            requiredFields={this.state.RequiredFields}
                                            editPermission={this.props.menuPermissionItem.Edit}
                                            dateChange={this.dateChange}
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(WorkplaceApproval));

